module.exports = __webpack_public_path__ + "media/images/press/transparent-ceramic-pro-logos-d94b981d1e874034402dab0356a97965.png";